import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d4b49cfe&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d4b49cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b49cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b49cfe')) {
      api.createRecord('d4b49cfe', component.options)
    } else {
      api.reload('d4b49cfe', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d4b49cfe&scoped=true&", function () {
      api.rerender('d4b49cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wI6B5znPJXCu/JS/comp/DocBox.vue"
export default component.exports